import React from "react";
import RequestUserAccountForm from "../../../components/app/account-management/request-user-account/RequestUserAccountForm";

const NewRequestUserAccountPage = () => {
  return (
    <RequestUserAccountForm />
  )
}

export default NewRequestUserAccountPage;
